import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.471 2.195c.26.26.26.683 0 .943L3.61 6l2.862 2.862a.667.667 0 0 1-.942.943L2.195 6.47a.667.667 0 0 1 0-.942L5.53 2.195c.26-.26.682-.26.942 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 6c0-.369.298-.667.667-.667h8A3.333 3.333 0 0 1 14 8.666v4.667a.667.667 0 0 1-1.333 0V8.666a2 2 0 0 0-2-2h-8A.667.667 0 0 1 2 6",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })